import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce } from "lodash";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tabs,
  Tooltip,
  Typography,
  message,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import moment from "moment-jalaali";
import { SetRoute } from "../scripts/action";
import { CheckPermission } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import MessageForm from "../forms/Message";
import MessageView from "../views/Message";
import Rules from "../scripts/rules";

class MessagesPage extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "one",
      checkedList: [],
      drafts: [],
      messages: [],
      draftPagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      messagePagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      userPagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selectedMessage: {},
      selectedUsers: [],
      users: [],
    };

    this.messageFormRef = React.createRef();
    this.notificationFormRef = React.createRef();

    this.handleMessageSearch = debounce(this.handleMessageSearch, 1000);
  }

  fetchDrafts = () => {
    this.setState({ loading: true });

    API.message
      .draftList()
      .then((result) => {
        this.setState({
          loading: false,
          drafts: result.data,
          draftPagination: {
            ...this.state.draftPagination,
            ...{
              total: result.data.length,
            },
          },
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchMessages = (params = {}) => {
    this.setState({ loading: true });

    params.q = this.state.filterMessageSearch;

    API.message
      .list(params)
      .then((result) => {
        if (result.data.data) {
          console.log(result.data.data);
          this.setState({
            loading: false,
            messages: result.data.data,
            messagePagination: {
              ...this.state.messagePagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchUsers = () => {
    this.setState({ loading: true });

    API.user
      .list()
      .then((result) => {
        this.setState({
          loading: false,
          users: result.data,
          userPagination: {
            ...this.state.userPagination,
            ...{
              total: result.data.length,
            },
          },
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showMessageForm = (message = {}) => {
    this.setState({ visibleMessageForm: true, selectedMessage: message });

    setTimeout(() => {
      this.messageFormRef.current.handleDidMount(message);
    }, 0);
  };

  hideMessageForm = () => {
    this.setState({ visibleMessageForm: false });
  };

  showMessageView = (message = {}) => {
    this.setState({ visibleMessageView: true, selectedMessage: message });
  };

  hideMessageView = () => {
    this.setState({ visibleMessageView: false });
  };

  handleCheckAll = (e) => {
    this.setState({
      checkedList: e.target.checked
        ? ["vip", "gold", "silver", "bronze", "normal"]
        : [],
      indeterminate: false,
      checkAll: e.target.checked,
    });
  };

  handleCheckBox = (values) => {
    this.setState({
      checkedList: values,
      indeterminate: !!values.length && values.length < 5,
      checkAll: values.length === 5,
    });
  };

  handleUserFilter = (values) => {
    this.setState({ filterUserCheckbox: values });
  };

  handleSelectDraft = (value) => {
    const draft = this.state.drafts.find((o) => o.id === value);
    this.notificationFormRef.current.setFieldsValue(draft);
  };

  handleSelectUser = (selectedUsers) => {
    this.setState({ selectedUsers });
  };

  handleDraftSearch = (value) => {
    this.setState({ filterDraftSearch: value });
  };

  handleMessageSearch = (value) => {
    this.setState({ filterMessageSearch: value });

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  handleUserSearch = (value) => {
    this.setState({ filterUserSearch: value });
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });

    if (tab === "three" && !this.state.messages.length)
      this.fetchMessages({ page: 1 });
  };

  handleDraftTable = (pagination) => {
    this.setState({
      draftPagination: {
        ...this.state.draftPagination,
        ...{ current: pagination.current },
      },
    });
  };

  handleMessageTable = (pagination) => {
    this.fetchMessages({ page: pagination.current });
  };

  handleUserTable = (pagination) => {
    this.setState({
      userPagination: {
        ...this.state.userPagination,
        ...{ current: pagination.current },
      },
    });
  };

  handleDeleteDraft = (id) => {
    Modal.confirm({
      title: Resources.confirmDeleteMessage,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.message
          .deleteDraft(id)
          .then((result) => {
            message.success(result.message);

            this.fetchDrafts();
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleDeleteMessage = (id) => {
    Modal.confirm({
      title: Resources.confirmDeleteMessage,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.message
          .delete(id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmitMessage = (values) => {
    const action = this.state.selectedMessage.id
      ? API.message.updateDraft
      : API.message.addDraft;

    this.setState({ submitting: true });

    action(values, this.state.selectedMessage.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideMessageForm();
        this.fetchDrafts();
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleSubmitNotif = () => {
    this.notificationFormRef.current.validateFields().then((values) => {
      const { checkedList, selectedUsers } = this.state;
      const data = { ...values, ...{ group: [], usersId: [] } };

      this.setState({ submitting: true });

      if (checkedList.length < 5) {
        data.group = checkedList;

        selectedUsers.forEach((o) => {
          const user = this.state.users.find((p) => p.id === o);
          let valid = true;

          if (checkedList.indexOf("vip") >= 0 && user.isVip === 1)
            valid = false;

          if (checkedList.indexOf("gold") >= 0 && user.rank === "gold")
            valid = false;

          if (checkedList.indexOf("silver") >= 0 && user.rank === "silver")
            valid = false;

          if (checkedList.indexOf("bronze") >= 0 && user.rank === "bronze")
            valid = false;

          if (checkedList.indexOf("normal") >= 0 && !user.rank) valid = false;

          if (valid) data.usersId.push(o);
        });
      } else {
        data.group = ["all"];
      }

      API.message
        .add(data)
        .then((result) => {
          message.success(result.message);
          this.setState({
            submitting: false,
            checkedList: [],
            selectedUsers: [],
          });
          this.notificationFormRef.current.resetFields();
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
    });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    if (this.props.permissions.add) this.fetchUsers();
    else this.setState({ activeTab: "two" });

    this.fetchDrafts();
  }

  render() {
    const {
      activeTab,
      checkAll,
      checkedList,
      drafts,
      indeterminate,
      loading,
      messages,
      filterDraftSearch,
      filterUserCheckbox,
      filterUserSearch,
      selectedMessage,
      selectedUsers,
      submitting,
      users,
      visibleMessageForm,
      visibleMessageView,
    } = this.state;
    const { permissions } = this.props;

    const draftColumns = [
      {
        title: Resources.dateAndTime,
        dataIndex: "created_at",
        className: "col-ltr",
        width: "140px",
        render: (val) => moment(val).format(Constants.jDateTimeFormat),
      },
      {
        title: Resources.title,
        dataIndex: "title",
        render: (val) => (
          <Typography.Paragraph ellipsis={{ rows: 5 }}>
            {val}
          </Typography.Paragraph>
        ),
      },
      {
        title: `${Resources.text} ${Resources.message}`,
        dataIndex: "body",
        render: (val) => (
          <Typography.Paragraph ellipsis={{ rows: 5 }}>
            {val}
          </Typography.Paragraph>
        ),
      },
    ];

    const messageColumns = [
      {
        title: Resources.dateAndTime,
        dataIndex: "created_at",
        className: "col-ltr",
        width: "140px",
        render: (val) => moment(val).format(Constants.jDateTimeFormat),
      },
      {
        title: Resources.fullName,
        dataIndex: "user",
        render: (val, record) => val?.name + " "+ val?.family,
      },
      {
        title: Resources.title,
        dataIndex: "title",
        render: (val) => (
          <Typography.Paragraph ellipsis={{ rows: 5 }}>
            {val}
          </Typography.Paragraph>
        ),
      },
      {
        title: `${Resources.text} ${Resources.message}`,
        dataIndex: "body",
        render: (val) => (
          <Typography.Paragraph ellipsis={{ rows: 5 }}>
            {val}
          </Typography.Paragraph>
        ),
      },
    ];

    const userColumns = [
      {
        title: Resources.fullName,
        dataIndex: "name",
        render: (val, record) =>
          record.name ? `${record.name} ${record.family}` : record.family,
      },
      {
        title: Resources.mobile,
        dataIndex: "phone",
        className: "col-center",
        width: "120px",
      },
      {
        title: Resources.rank,
        dataIndex: "type",
        className: "col-center",
        width: "100px",
        render: (val) => val || "-",
      },
      {
        title: "VIP",
        dataIndex: "isVip",
        className: "col-center",
        width: "70px",
        render: (val) => (!!parseInt(val) ? "VIP" : "-"),
      },
    ];

    const userOptions = [{ label: Resources.vip, value: "vip" }];

    const filtredUsers = users.filter((o) => {
      let filter = false;
      let query = false;

      if (filterUserCheckbox && filterUserCheckbox.length) {
        if (filterUserCheckbox.indexOf("vip") >= 0 && o.isVip === 1)
          filter = true;

        if (filterUserCheckbox.indexOf("normal") >= 0 && !o.rank) filter = true;
      } else {
        filter = true;
      }

      if (filterUserSearch) {
        if (o.name && o.name.indexOf(filterUserSearch) >= 0) query = true;

        if (o.family && o.family.indexOf(filterUserSearch) >= 0) query = true;

        if (o.phone && o.phone.indexOf(filterUserSearch) >= 0) query = true;
      } else {
        query = true;
      }

      return filter && query;
    });

    if (permissions.receive) {
      draftColumns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.view}>
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => this.showMessageView(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showMessageForm(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDeleteDraft(val)}
              />
            </Tooltip>
          </Fragment>
        ),
      });

      messageColumns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.view}>
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => this.showMessageView(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDeleteMessage(val)}
              />
            </Tooltip>
          </Fragment>
        ),
      });
    }

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.messages}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Tabs
            activeKey={activeTab}
            type="card"
            onTabClick={this.handleTabChange}
          >
            {permissions.add && (
              <Tabs.TabPane tab={Resources.sendNotif} key="one">
                <Form ref={this.notificationFormRef} layout="vertical">
                  <Row gutter={24}>
                    <Col xs={24} md={12}>
                      <Form.Item name="draft" label={Resources.drafts}>
                        <Select
                          placeholder={Resources.choose}
                          onChange={this.handleSelectDraft}
                        >
                          {drafts.map((draft) => (
                            <Select.Option key={draft.id} value={draft.id}>
                              {draft.title}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="title"
                        label={Resources.title}
                        rules={Rules.required}
                      >
                        <Input type="text" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        name="body"
                        label={Resources.text}
                        rules={Rules.required}
                      >
                        <Input.TextArea style={{ height: 128 }} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <Divider>
                  {Resources.submit} {Resources.grouping}
                </Divider>
                <Checkbox
                  indeterminate={indeterminate}
                  onChange={this.handleCheckAll}
                  checked={checkAll}
                  style={{ marginLeft: 20 }}
                >
                  <Typography.Text strong>
                    {Resources.sendToAll}
                  </Typography.Text>
                </Checkbox>
                <Checkbox.Group
                  value={checkedList}
                  onChange={this.handleCheckBox}
                >
                  <Checkbox value="vip">{Resources.sendToVIP}</Checkbox>
                </Checkbox.Group>
                <Divider style={{ marginTop: 32 }}>
                  {Resources.submit} {Resources.dedicated}
                </Divider>
                <Row gutter={24}>
                  <Col xs={24} md={18} style={{ paddingTop: 8 }}>
                    <Checkbox.Group
                      options={userOptions}
                      onChange={this.handleUserFilter}
                    />
                  </Col>
                  <Col xs={24} md={6}>
                    <Tooltip title={Resources.searchHintMessageUser}>
                      <Input
                        type="text"
                        prefix={<SearchOutlined />}
                        placeholder={Resources.search}
                        onChange={({ target: { value } }) =>
                          this.handleUserSearch(value)
                        }
                        allowClear
                      />
                    </Tooltip>
                  </Col>
                  <Col xs={24} style={{ paddingTop: 16 }}>
                    <Table
                      columns={userColumns}
                      dataSource={filtredUsers}
                      loading={loading}
                      onChange={this.handleUserTable}
                      rowSelection={{
                        selectedRowKeys: selectedUsers,
                        onChange: this.handleSelectUser,
                      }}
                      size="small"
                      rowKey="id"
                      scroll={{ x: 600 }}
                    />
                  </Col>
                  <Col
                    xs={24}
                    md={{ span: 4, offset: 20 }}
                    style={{ paddingTop: 32 }}
                  >
                    <Button
                      type="primary"
                      onClick={this.handleSubmitNotif}
                      loading={submitting}
                      disabled={!checkedList.length && !selectedUsers.length}
                      block
                    >
                      {Resources.submit}
                    </Button>
                  </Col>
                </Row>
              </Tabs.TabPane>
            )}
            <Tabs.TabPane
              tab={`${Resources.list} ${Resources.drafts}`}
              key="two"
            >
              <Row gutter={24} style={{ marginBottom: 16 }}>
                <Col xs={24} md={4}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => this.showMessageForm()}
                    block
                  >
                    {Resources.add}
                  </Button>
                </Col>
                <Col xs={24} md={{ span: 6, offset: 14 }}>
                  <Tooltip title={Resources.search}>
                    <Input
                      type="text"
                      prefix={<SearchOutlined />}
                      placeholder={Resources.search}
                      onChange={({ target: { value } }) =>
                        this.handleDraftSearch(value)
                      }
                      allowClear
                    />
                  </Tooltip>
                </Col>
              </Row>
              <Table
                columns={draftColumns}
                dataSource={
                  filterDraftSearch
                    ? drafts.filter(
                        (o) => o.title.indexOf(filterDraftSearch) >= 0
                      )
                    : drafts
                }
                loading={loading}
                onChange={this.handleDraftTable}
                size="small"
                rowKey="id"
                scroll={{ x: 1000 }}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.receivedMessage} key="three">
              <Row gutter={24} style={{ marginBottom: 16 }}>
                <Col xs={24} md={{ span: 6, offset: 18 }}>
                  <Tooltip title={Resources.search}>
                    <Input
                      type="text"
                      prefix={<SearchOutlined />}
                      placeholder={Resources.search}
                      onChange={({ target: { value } }) =>
                        this.handleMessageSearch(value)
                      }
                      allowClear
                    />
                  </Tooltip>
                </Col>
              </Row>
              <Table
                columns={messageColumns}
                dataSource={messages}
                loading={loading}
                onChange={this.handleMessageTable}
                size="small"
                rowKey="id"
                scroll={{ x: 1000 }}
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
        <MessageView
          data={selectedMessage}
          visible={visibleMessageView}
          onClose={this.hideMessageView}
        />
        <MessageForm
          ref={this.messageFormRef}
          onCancel={this.hideMessageForm}
          onSubmit={this.handleSubmitMessage}
          submitting={submitting}
          visible={visibleMessageForm}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        add: CheckPermission(state.app.user, Permissions.message_store),
        receive: CheckPermission(state.app.user, Permissions.message_receipt),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(MessagesPage);
